@if (isLabelValueSplit) {
    <div class="part" fxLayout="row">
        @if (showLabel) {
            <div
                class="partLabelSplit ellipsis"
                [fxFlex]="100 - valueSize"
                [fxLayoutAlign]="getVerticalHorizontalAlign(part.field.labelFormatting)"
                [style.color]="getFontColor(part.field.labelFormatting)"
                [style.fontSize]="getFontSize(part.field.labelFormatting)"
                [style.fontWeight]="getFontWeight(part.field.labelFormatting)"
                [style.fontStyle]="getFontStyle(part.field.labelFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.labelFormatting)"
                [title]="part.field.label">
                {{ part.field.label }}{{ part.field.labelFormatting.showColon ? ":" : "" }}
            </div>
        }
        <div
            [fxFlex]="valueSize"
            class="partValueSplit"
            [fxLayoutAlign]="getVerticalHorizontalAlign(part.field.valueFormatting)"
            [style.color]="getFontColor(part.field.valueFormatting)"
            [style.fontSize]="getFontSize(part.field.valueFormatting)"
            [style.fontWeight]="getFontWeight(part.field.valueFormatting)"
            [style.fontStyle]="getFontStyle(part.field.valueFormatting)"
            [style.textDecoration]="getTextDecoration(part.field.valueFormatting)">
            <ng-container [ngTemplateOutlet]="valueFormatTpl"></ng-container>
        </div>
    </div>
}

@if (isLabelValueJoin) {
    <div class="part" fxLayout="row">
        <div fxFlex [fxLayoutAlign]="getVerticalHorizontalAlign(part.field.valueFormatting)">
            <span
                class="partLabelJoin"
                [style.color]="getFontColor(part.field.labelFormatting)"
                [style.fontSize]="getFontSize(part.field.labelFormatting)"
                [style.fontWeight]="getFontWeight(part.field.labelFormatting)"
                [style.fontStyle]="getFontStyle(part.field.labelFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.labelFormatting)"
                [title]="part.field.label">
                {{ part.field.label }}{{ part.field.labelFormatting.showColon ? ":" : "" }}
            </span>
            &nbsp;
            <span
                class="partValueJoin"
                [style.color]="getFontColor(part.field.valueFormatting)"
                [style.fontSize]="getFontSize(part.field.valueFormatting)"
                [style.fontWeight]="getFontWeight(part.field.valueFormatting)"
                [style.fontStyle]="getFontStyle(part.field.valueFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.valueFormatting)">
                <ng-container [ngTemplateOutlet]="valueFormatTpl"></ng-container>
            </span>
        </div>
    </div>
}

@if (isLabelValueVertical) {
    <div class="part" fxLayout="column" [fxLayoutAlign]="getVerticalHorizontalAlign(part.field.valueFormatting)">
        <div class="partVertical">
            <div
                class="partLabelVertical"
                [style.color]="getFontColor(part.field.labelFormatting)"
                [style.fontSize]="getFontSize(part.field.labelFormatting)"
                [style.fontWeight]="getFontWeight(part.field.labelFormatting)"
                [style.fontStyle]="getFontStyle(part.field.labelFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.labelFormatting)"
                [title]="part.field.label">
                {{ part.field.label }}{{ part.field.labelFormatting.showColon ? ":" : "" }}
            </div>
            <div
                class="partValueVertical"
                [style.color]="getFontColor(part.field.valueFormatting)"
                [style.fontSize]="getFontSize(part.field.valueFormatting)"
                [style.fontWeight]="getFontWeight(part.field.valueFormatting)"
                [style.fontStyle]="getFontStyle(part.field.valueFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.valueFormatting)">
                <ng-container [ngTemplateOutlet]="valueFormatTpl"></ng-container>
            </div>
        </div>
    </div>
}

<ng-template #valueFormatTpl>
    @if (part.isNumber && part.valueNumber) {
        @if (part.isNumberIndicator) {
            <ng-container [ngTemplateOutlet]="numberIndicatorTpl"></ng-container>
        }
        @if (part.isNumberProgress) {
            <ng-container [ngTemplateOutlet]="numberProgressTpl"></ng-container>
        }
        @if (!part.isNumberIndicator && !part.isNumberProgress) {
            <ng-container [ngTemplateOutlet]="numberTpl"></ng-container>
        }
    }
    @if (part.isDate && part.valueString) {
        <span [title]="part.valueString | itvDateTimeWithRestrictions: part.field.restrictions">
            {{ part.valueString | itvDateTimeWithRestrictions: part.field.restrictions }}
        </span>
    }
    @if (part.isText) {
        <span [title]="part.valueString" [innerHTML]="part.valueString"></span>
    }
    @if (part.isYesNo) {
        <ng-container [ngTemplateOutlet]="yesNoTpl"></ng-container>
    }
    @if (part.isState && part.valueState) {
        <ng-container [ngTemplateOutlet]="stateTpl"></ng-container>
    }
    @if (part.isLine) {
        <ng-container [ngTemplateOutlet]="lineTpl"></ng-container>
    }
</ng-template>

<ng-template #numberTpl>
    <span
        [title]="
            part.valueNumber
                | itvNumberWithFormattings: part.field.formattings : part.field.restrictions : part.currency
        ">
        {{
            part.valueNumber
                | itvNumberWithFormattings: part.field.formattings : part.field.restrictions : part.currency
        }}
    </span>
</ng-template>

<ng-template #numberIndicatorTpl>
    <mat-icon class="indicator-icon">
        {{ part.isNumberIndicatorDown ? "arrow_drop_down" : "arrow_drop_up" }}
    </mat-icon>
    <ng-container *ngTemplateOutlet="numberTpl"></ng-container>
</ng-template>

<ng-template #numberProgressTpl>
    <itv-number-progress-bar
        [value]="numberProgressValue"
        [formattings]="part.field.formattings"
        [restrictions]="part.field.restrictions"
        [isDuration]="part.isNumberDurationProgress"></itv-number-progress-bar>
</ng-template>

<ng-template #yesNoTpl>
    {{ part.valueString ? part.valueString : part.valueBoolean ? "Yes" : "No" }}
</ng-template>

<ng-template #stateTpl>
    <cipo-state
        [customClass]="'stateBlock'"
        [name]="part.valueState.label"
        [bgColor]="part.valueState.bgColor"
        [textColor]="part.valueState.color"
        [fontWeight]="getFontWeight(part.field.valueFormatting)"
        [fontStyle]="getFontStyle(part.field.valueFormatting)"
        [textDecoration]="getTextDecoration(part.field.valueFormatting)"
        [fontSize]="getFontSize(part.field.valueFormatting)" />
</ng-template>

<ng-template #lineTpl>
    <hr class="lineBlock" [style.borderTopColor]="getFontColor(part.field.valueFormatting)" />
</ng-template>
